import http from "./http";
const api =  {
  userLogin(param){
    return http.post('/api/crm/login',param)
  },
  userAutoLogin(param){
    return http.post('/api/crm/autoLogin',param)
  },
  getUserCorp(){
    return http.get('/api/crm/corp')
  },
  getUserinfo(id){
    return http.post('/api/crm/userinfo',{id})
  },
  getSignList(){
    return http.get('/api/crm/sign')
  },
  getCityList(param){
    return http.get('/api/crm/city',param)
  },
  getChannelList(param){
    return http.post('/api/crm/channel',param)
  },
  getSourceList(param){
    return http.post('/api/crm/source',param)
  },
  getBankList(param){
    return http.post('/api/crm/bank',param)
  },
  getBranchAndProduct(param){
    return http.post('/api/crm/product',param)
  },
  addClientInfo(param){
    return http.post('/api/crm/addClient',param)
  },
  getClientList(param){
    return http.post('/api/crm/clientList',param)
  },
  getClientDetail(param){
    return http.get('/api/crm/detail',param)
  },
  delClientList(param){
    return http.post('/api/crm/delClient',param)
  },
  getMoneyList(param){
    return http.post('/api/crm/moneyList',param)
  },
  getMoneyConfirm(param){
    return http.post('/api/crm/moneyConfirm',param)
  },
  addMoneyInfo(param){
    return http.post('/api/crm/addMoney',param)
  },
  delMoneyInfo(param){
    return http.post('/api/crm/delMoney',param)
  },
  addMoneyProof(param){
    return http.post('/api/crm/proof',param)
  },
  getMoneyProof(param){
    return http.get('/api/crm/getProof',param)
  },
  updateMoneyProof(param){
    return http.post('/api/crm/updateProof',param)
  },
  deleteMoneyProof(param){
    return http.post('/api/crm/delProof',param)
  },
  addClientAppeal(param){
    return http.post('/api/crm/addAppeal',param)
  },
  getClientAppeal(param){
    return http.get('/api/crm/appeal',param)
  },
  getPendingList(param){
    return http.post('/api/crm/pending',param)
  },
  getPendingDetail(param){
    return http.get('/api/crm/pendingDetail',param)
  },
  getProofRejectList(param){
    return http.get('/api/crm/proofReject',param)
  },
  getStatisticData(param){
    return http.get('/api/crm/statistic',param)
  },
  getStatisticUserlist(param){
    return http.get('/api/crm/statUserlist',param)
  },
  //房贷业务
  getMortgageUser(param){
    return http.post('/api/crm/mortgageUser',param)
  },
  getFinancePact(param){
    //return http.get('/api/crm/financePact',param)
    return http.get('/api/crm/financePactWarn',param)
  },
  addHouseClientInfo(param){
    return http.post('/api/crm/addHouseClient',param)
    //return http.post('/api/crm/addHouseClientTest',param)
  },
  addHouseClientImage(param){
    return http.post('/api/crm/addHouseImg',param)
  },
  getHouseAuditList(param){
    return http.post('/api/crm/getHouseAudit',param)
  },
  updateHouseAudit(param)
  {
    return http.post('/api/crm/updateHouseAudit',param)
  },
  updateHouseBrokerageStatus(param)
  {
    return http.post('/api/crm/updateHouseBrokerageStatus',param)
  },
  getHouseClientList(param){
    return http.post('/api/crm/getHouseList',param)
  },
  getHouseClientList2(param){
    return http.post('/api/crm/getHouseList2',param)
  },
  getHouseBrokerageOrder(param){
    return http.post('/api/crm/houseBrokerageOrder',param)
  },
  //发起房贷审批
  launcHouseBrokerageApprove(param){
    return http.post('/api/crm/wxWorkApprove',param)
  },
  getHouseBrokerageOrderList(param){
    return http.post('/api/crm/houseBrokerageOrderList',param)
  },
  updateHouseBrokerageOrderStatus(param){
    return http.post('/api/crm/updateHouseBrokerageOrder',param)
  },
  //设置客户返佣打款方式（房贷主管操作）
  setHouseBrokeragePayMethod(param){
    return http.post('/api/crm/setHouseBrokeragePayMethod',param)
  },
  //生成返佣单（房贷主管操作）
  createHouseBrokerageBill(param){
    return http.post('/api/crm/houseBrokerage',param)
  },
  getHouseCardList(param){
    return http.post('/api/crm/getHouseCard',param)
  },
  getHouseClientDetail(param){
    return http.get('/api/crm/getHouseDetail',param)
  },
  getHouseClientImage(param){
    return http.get('/api/crm/getHouseImg',param)
  },
  delHouseClient(param){
    return http.post('/api/crm/delHouseClient',param)
  },
  addHouseChannel(param){
    return http.post('/api/crm/addHouseChannel',param)
  },
  getHouseChannelList(param){
    return http.post('/api/crm/getHouseChannelList',param)
  },
  addHouseRecommend(param){
    return http.post('/api/crm/addHouseRecommend',param)
  },
  getHouseRecommend(param){
    return http.post('/api/crm/getHouseRecommend',param)
  },
  addHouseBrokerageUser(param){
    return http.post('/api/crm/addHouseBrokerageUser',param)
  },
  getHouseBrokerageUser(param){
    return http.post('/api/crm/houseBrokerageUser',param)
  },
  getHouseBrokerageList(param){
    return http.post('/api/crm/houseBrokerageList',param) 
  },
  //申请返佣（业务员操作，填写返佣金额、选择返佣账户）
  setHouseBrokerage(param){
    return http.post('/api/crm/setHouseBrokerage',param)
  },
  //房贷业务授信额度提额审批
  addFinanceApprove(param){
    return http.post('/api/crm/addFinanceApprove',param)
  },
  getFinanceApprove(param){
    return http.post('/api/crm/getFinanceApprove',param)
  },

  getHouseBankManagerList(param){
    return http.post('/api/crm/bankManagerList',param)
  },
  //房贷业务客户端
  houseChannelLogin(param){
    return http.post('/api/houseloan/login',param)
  },
  getHouseBank(param){
    return http.get('/api/houseloan/bank',param)
  },
  getHouseService(){
    return http.get('/api/houseloan/service')
  },
  getHouseWaiter(){
    return http.get('/api/houseloan/waiter')
  },
  addHouseClient(param){
    return http.post('/api/houseloan/add',param)
  },
  getHouseClientData(param){
    return http.post('/api/houseloan/list',param)
  },
  getHouseClientBrokerage(param){
    return http.post('/api/houseloan/brokerage',param)
  },
  getHouseClientSignData(param){
    return http.post('/api/houseloan/sign',param)
  },
  getHouseClient(param){
    return http.post('/api/houseloan/detail',param)
  },
  getHouseClientStatus(){
    return http.get('/api/houseloan/status')
  },
  allotHouseClient(param){
    return http.post('/api/houseloan/allot',param)
  },
  bankManagerLogin(param){
    return http.post('/api/houseloan/bankManagerLogin',param)
  },
  updateBankManager(param){
    return http.post('/api/houseloan/updateBankManager',param)
  },
  getBankManagerTeam(param){
    return http.post('/api/houseloan/getBankManagerTeam',param)
  },
  //活动
  addActivityData(param){
    return http.post('/api/crm/addActivityData',param)
    //return http.post('/api/crm/activityAdd',param)
  },
  getActivityInfo(param){
    return http.post('/api/crm/getActivityinfo',param)
  },
  getActivityDataList(param){
    return http.post('/api/crm/getActivityDataList',param)
  },
  activityLotteryLogin(param){
    return http.post('/api/crm/lotteryLogin',param)
  },
  activityCouponLogin(param){
    return http.post('/api/crm/coupon',param)
  },
  //意数宝
  getYsbQrcode(param){
    return http.post('/api/crm/ysbQrcode',param)
  },
  getYsbDataList(param){
    return http.post('/api/crm/ysbUser',param)
  },
  getYsbUserinvite(param){
    return http.post('/api/crm/ysbInvite',param)
  },
  getYsbOutsideClient(param){
    return http.post('/api/crm/ysbOutsideClient',param)
  },
  getYsbClient(param){
    return http.post('/api/crm/ysbClient',param)
  },
  //客服协助
  getServiceDataList(param){
    return http.get('/api/crm/service',param)
  },
  serviceTransfer(param){
    return http.post('/api/crm/serviceTransfer',param)
  },
  //团队
  getTeamData(param){
    return http.get('/api/crm/teamData',param)
  },
  getTeamDataList(param){
    return http.post('/api/crm/teamDataList',param)
  },
  getTeamAppeal(param){
    return http.get('/api/crm/teamAppeal',param)
  },
  getTeamHouse(param){
    return http.get('/api/crm/houseTeam',param)
  },
  getTeamYsb(param){
    return http.post('/api/crm/ysbTeam',param)
  },
  auditAppeal(param){
    return http.post('/api/crm/auditAppeal',param)
  },
  // 签约
  getTaskInfo(param){
    return http.post('/api/crm/taskList',param)
  },
  updateClict(param){
    return http.post('/api/crm/updateClient',param)
  },
  updateClientStatus(param){
    return http.post('/api/crm/updateClientStatus',param)
  },
  rejectUpdate(param){
    return http.post('/api/crm/updateClientReject',param)
  },
  //考试
  getPaperList(param){
    return http.get('/api/crm/paperList',param)
  },
  getPaperDetail(param){
    return http.get('/api/crm/paperDetail',param)
  },
  addPaperAnswer(param){
    return http.post('/api/crm/paperAnswer',param)
  },
  getAnswerList(param){
    return http.get('/api/crm/answerList',param)
  },
  getAnswerDetail(param){
    return http.get('/api/crm/answerDetail',param)
  },

  //渠道进件
  getOutsideUser(param){
    return http.get('/api/crm/getOutsideUser',param)
  },
  getOutsideUserTeam(param){
    return http.get('/api/crm/getOutsideUserTeam',param)
  },
  addOutsideUser(param){
    return http.post('/api/crm/outsideRegister',param)
  },
  outsideUserLogin(param){
    return http.post('/api/crm/outsideLogin',param)
  },
  addOutsideChennelClient(param){
    return http.post('/api/crm/outsideChannelAdd',param)
  },
  getOutsideProduct(param){
    return http.get('/api/crm/outsideProduct',param)
  },
  getOutsideBank(param){
    return http.get('/api/crm/outsideBank',param)
  },
  getOutsideBranchBank(param){
    return http.get('/api/crm/outsideBranchBank',param)
  },
  getOutsideClientList(param){
    return http.get('/api/crm/outsideClientList',param)
  },
  getOutsideClientDetail(param){
    return http.get('/api/crm/outsideClientDetail',param)
  },
  updateOutsideClientStatus(param){
    return http.post('/api/crm/updateOutsideClient',param)
  },
  addOutsideChannel(param){
    return http.post('/api/crm/outsideAddChannel',param)
  },
  deleteOutsideChannel(param){
    return http.get('/api/crm/outsideDelChannel',param)
  },
  outsideChannelList(param){
    return http.get('/api/crm/outsideChannelList',param)
  },
  //小意问答
  getFaqType(){
    return http.get('/api/crm/faqType')
  },
  getFaqCategory(param){
    return http.get('/api/crm/faqCategory',param)
  },
  getFaqList(param){
    return http.post('/api/crm/faqList',param)
  },
  getFaqDetail(param){
    return http.post('/api/crm/faqDetail',param)
  },
  getFaqCopilot(param){
    return http.post('/api/crm/faqCopilot',param)
  },
  //渠道建档(乾太健钱包)
  initWxWorkConfig(param){
    return http.post('/api/chattergee/initWxWorkConfig',param)
  },
  addChattergeeUser(param){
    return http.post('/api/chattergee/addFiling',param)
  },
  getChattergeeUser(param){
    return http.post('/api/chattergee/getFiling',param)
  },
  getIntegralList(param){
    return http.post('/api/chattergee/getIntegral',param)
  },
  sendIntegral(param){
    return http.post('/api/chattergee/sendPoint',param)
  },
  sendQrcode(param){
    return http.post('/api/chattergee/sendQrcode',param)
  },
  getChattergeeUserList(param){
    return http.post('/api/chattergee/userlist',param)
  },
  //OA审批
  oaTest(param){
    return http.get('/api/oa/test',param)
  },
  //工行e分期
  esignAdd(param){
    return http.post('/api/esign/add',param)
  },
  esignOpen(param){
    return http.post('/api/esign/open',param)
  },
  esignList(param){
    return http.post('/api/esign/list',param)
  },
  esignEvidence(param){
    return http.post('/api/esign/evidence',param)
  },
  esignCreateOrder(param){
    return http.post('/api/esign/order',param)
  },
  //公共部分
  OCRImage(param){
    return http.post('/api/ysb/uploadImg',param)
  },
  getStatusList(){
    return http.get('/common/status')
  },
  getOutsideStatus(){
    return http.get('/common/outsideStatus')
  },
  getHouseStatus(param){
    return http.get('/common/houseStatus',param)
  },
  getBankTree(param){
    return http.get('/common/bankTree',param)
  },
  getChannelTree(param){
    return http.get('/common/channelTree',param)
  },
  getRegionList(){
    return http.get('/common/region')
  },
  getSignUser(param){
    return http.get('/common/signUser',param)
  },
  uploadImage(param){
    return http.post('/api/ysb/uploadImg',param)
  },
  deleteImage(param){
    return http.post('/common/delimg',param)
  },
  getPhoneCode(param){
    //return http.get('/common/code',param)
    return http.post('/common/smsCode',param)
  },
  checkCaptcha(param){
    return http.get('/common/checkCaptcha',param)
  },
  addWorkList(param){
    return http.post('/common/wxwork/addWorkList',param)
  },
  getWorkList(param){
    return http.get('/common/wxwork/workList',param)
  }

}

export default api